import { useState } from "react";
import Modal from "../../components/Modal";
import { Step1 } from "./Steps/Step1";
import { Step2 } from "./Steps/Step2";
import { Step3 } from "./Steps/Step3";
import { Step4 } from "./Steps/Step4";
import { Step5 } from "./Steps/Step5";
import { Step6 } from "./Steps/Step6";
import { StepProgress } from "./StepProgress";
import { Step1_5 } from "./Steps/Step1_5";

const TOTAL_STEP = 7;

const steps = {
    1: Step1,
    2: Step1_5,
    3: Step2,
    4: Step3,
    5: Step4,
    6: Step5,
    7: Step6
}

export function Onboarding({ onClose }: { onClose: () => void }) {
    const [step, setStep] = useState(1);
    const [onboardingForm, setOnboardingForm] = useState<{
        sales_experience: string;
    }>({
        sales_experience: "",
    });

    const handleContinue = () => {
        if (step < TOTAL_STEP) {
            setStep(prev => prev + 1);
        } else {
            // Last step (Step6): close modal; tooltip tutorial will show after questionnaire is completed
            onClose();
        }
    }

    const handleRestart = () => {
        setStep(1);
    }

    const handleCloseModal = () => {
        onClose();
    };

    const Component = steps[step];

    return (<Modal
        isOpen={true}
        title="Welcome to PraxisPlay"
        contentClassName="[&_.title]:!text-[25px] [&_.title]:!font-medium [&_.title-container]:!px-2"
        handleModal={handleCloseModal}
    >
        <div className="flex flex-col gap-4 px-2 mt-4">
            <StepProgress totalSteps={TOTAL_STEP} currentStep={step} onRestart={handleRestart} />
            <Component
                onContinue={handleContinue}
                onSkip={onClose}
                onboardingForm={onboardingForm}
                setOnboardingForm={setOnboardingForm}
            />
        </div>
    </Modal>);
}